import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { SplashScreen } from 'z-react-components';

import * as appPropTypes from '../lib/appPropTypes';
import PublicHome from '../components/PublicHome';
import LandingV2 from '../containers/landing-v2';
import userHasAccess from '../lib/userHasAccess';
import { FUNCTIONARY, STUDENT, TEACHER } from '../constants/UserRoles';
import Unauthorized from '../containers/Unauthorized';

import { FEATURE_TOGGLE_NEW_PUBLIC_HOME } from '../config';

export default class PrivatePage extends PureComponent {
    static propTypes = {
        auth: appPropTypes.auth.isRequired,
        authorizedRoles: PropTypes.arrayOf(PropTypes.oneOf([FUNCTIONARY, STUDENT, TEACHER])),
        component: PropTypes.func,
        name: PropTypes.string,
        path: PropTypes.string
    };

    static defaultProps = {
        authorizedRoles: [],
        name: '',
        path: ''
    };

    render() {
        const {
            auth: { isLoggedIn, isLoggingIn, isResumingLogin, user },
            authorizedRoles,
            component: ChildComponent,
            name,
            path
        } = this.props;

        if (isLoggingIn || isResumingLogin) {
            return (
                <div style={{ zIndex: 10002 }}>
                    <SplashScreen logoSrc="./_assets/images/logo_positivo.svg" color="#f9ae42" />
                </div>
            );
        }

        if (isLoggedIn) {
            const userHasAccessCheck = userHasAccess(user, authorizedRoles);
            if (!userHasAccessCheck.hasAccess) {
                return <Route className={'unauthorized'} name={name} path={path} render={props => <Unauthorized {...props} />} />;
            }
            return <Route className={'z-route'} name={name} path={path} render={props => <ChildComponent {...props} />} />;
        }

        return (
            <Route
                className={'public-home'}
                name={name}
                path={path}
                render={() => (FEATURE_TOGGLE_NEW_PUBLIC_HOME === 'enable' ? <LandingV2 /> : <PublicHome />)}
            />
        );
    }
}
